import moment from "moment-jalaali";




export const onCustomPrint = (props) => {
    const { selectedColumns } = props.state;
    let { dataPrint, printTitle, columns, properties } = props;
    let options = {};
    let tmpOptions = {};
    let header = {};

    app._.map(columns, (column) => {
      if (
        selectedColumns.indexOf(column.key) > -1 ||
        app._.isEmpty(selectedColumns)
      ) {
        header[column.key] = {
          title: column.title,
          type: column.valuesType,
          props: column.props,
        };
      }
    });
    options.tables = [];
    options.footer = [];

    options.header = {
      pageTitle: "پرینت " + printTitle,
    };

    dataPrint.map((table, index) => {
      tmpOptions.tableLeader = {
        personName:
          table.props?.user && table.props?.user.profile
            ? table.props?.user.profile.firstName
            : "",
        personFamily:
          table.props?.user && table.props?.user.profile
            ? table.props?.user.profile.lastName
            : "",
        personCode:
          table.props?.user && table.props?.user.profile
            ? table.props?.user?.profile?.personnelId
            : "",
        tableTitle: printTitle ? printTitle : "گزارش ...",
        reportDate:
          properties && properties.date
            ? "rthrthrth"
            : "ghhjghjtyjt",
        dateFrom:
          properties && properties?.range
            ? "hggjkhjk"
            : "",
        dateTo:
          properties && properties?.range
            ? "gjtyjtyjtyj"
            : "",
        recruitmentType: table.props?.recruitmentType
          ? table.props?.recruitmentType
          : "-",
        department: table.props?.department
          ? `واحد : ${table.props?.department}`
          : " ",
        pageNumber: index + 1,
      };
      tmpOptions.tableHeader = header;
      tmpOptions.tableBody = table.body;
      tmpOptions.tableFooter = {
        signers: properties && properties.signers ? properties.signers : [],
        descriptions:
          properties && properties.descriptions ? properties.descriptions : [],
      };
      tmpOptions.setting = {
        rejectedCols:
          properties && properties.rejectedCols ? properties.rejectedCols : [],
      };
      options.tables.push(tmpOptions);
      tmpOptions = [];
    });

    options.footer = [];
    let rp = new ReportPrint(options);
    rp.print(props);
  }

 export const onCancelCustomPrint = () => {
    this.setState({ showCustomPrint: false });
  }
/**
 * Generate unified table content for both normal and customise modes
 * @param {Array} PersonalInformation - Personal information data
 * @param {Boolean} pagePrint - Whether to include page breaks
 * @param {Boolean} isCustomiseMode - Whether in customise mode
 * @param {Object} props - Component props
 * @param {Object} state - Component state
 * @return {String} HTML table content
 */
export const generateUnifiedTableContent = (
  PersonalInformation,
  pagePrint,
  isCustomiseMode,
  props,
  state
) => {
  const { properties, dataPrint, printTitle, columns } = props;
  const { selectedColumns } = state;
  const CompanyCode = localStorage.getItem("CompanyCode");
  const isTotalReport = printTitle === "گزارش مجموع";

  const header = {};
  const mainBody = [];

  // در حالت عادی: سورت می‌کنیم، در حالت customise: سورت نمی‌کنیم
  const columnsToUse = isCustomiseMode
    ? columns
    : columns.sort((a, b) => (a.priority ?? 100) - (b.priority ?? 100));

  window.app._.map(columnsToUse, (column) => {
    if (
      selectedColumns.indexOf(column.key) > -1 ||
      window.app._.isEmpty(selectedColumns)
    ) {
      header[column.key] = {
        title: column.title,
        type: column.valuesType,
        props: column.props,
        priority: column.priority,
      };
      mainBody.push(column);
    }
  });

  // تعیین tableHeader بسته به نوع گزارش
  const wrapHeaderTitle = (title) => {
    const words = String(title || "").trim().split(/\s+/);
    if (words.length < 2) return words[0] || "";
    const middle = Math.ceil(words.length / 2);
    return `${words.slice(0, middle).join(" ")}<br/>${words.slice(middle).join(" ")}`;
  };

  const totalReportHeader = mainBody
    .map(
      (column) =>
        `<th style="height: 42px; padding: 3px 1px; border: 1px solid black; background-color: #ddd; color: black; text-align: center; vertical-align: middle; font-family: samim; font-size: 9px; font-weight: bold; line-height: 1.35; white-space: nowrap;">${wrapHeaderTitle(column.title)}</th>`
    )
    .join("");

  const tableHeader = isTotalReport
    ? totalReportHeader
    : !isCustomiseMode && printTitle === "گزارش مانده مرخصی"
    ? renderTableHeader(columnsToUse)
    : renderTableHeader(header);

  const formatDate = (date) => moment(date).format("jYYYY-jMM-jDD");

  const formatStatus = (status) => {
    const statusMap = {
      accepted: "تایید تردد",
      waiting: "درانتظار تایید",
      default: "رد تردد",
    };
    return statusMap[status] || statusMap.default;
  };

  // سایز فونت بسته به حالت
  const fontSize = isTotalReport ? "11px" : isCustomiseMode ? "7px" : "5.5px";

  const tabelRows = (item) =>
    item
      ?.map((row) => {
        let rowStyle = "";

        // فقط در حالت عادی چک می‌کنیم
        if (!isCustomiseMode) {
          if (props.report?.id === 213 && row?.presenceState === "تعطیل") {
            rowStyle = "background-color: #ffcccc;";
          } else if (row?._props?.type === "footer") {
            rowStyle = "background-color: #ddd;";
          }
        } else {
          if (row?._props?.type === "footer") {
            rowStyle = "background-color: #ddd;";
          }
        }

        const rowCells = mainBody
          .map((column) => {
            const baseStyle = `padding: ${isTotalReport ? "8px 2px" : "4px"}; border: 1px solid black; font-size: ${fontSize}; font-family: samim; font-weight: ${isTotalReport ? "bold" : "normal"}; white-space: nowrap; overflow: hidden; text-overflow: ellipsis`;

            if (column.key === "date") {
              return row.person || row.date
                ? `<td style="${baseStyle}; white-space: nowrap">${formatDate(
                    row[column.key]
                  )}</td>`
                : `<td style="${baseStyle}; white-space: nowrap"></td>`;
            }

            if (column.key === "datetime") {
              return `<td style="${baseStyle}; white-space: nowrap">${formatDate(
                row[column.key]
              )}</td>`;
            }

            if (column.key.includes("status")) {
              return `<td style="${baseStyle}">${formatStatus(
                row[column.key]
              )}</td>`;
            }

            if (row[column.key]) {
              return `<td style="${baseStyle}">${row[column.key]}</td>`;
            }

            // فقط در حالت عادی padding متغیر داریم
            const padding =
              !isCustomiseMode && row["dayMonth"] ? "15px 4px" : "4px";
            return `<td style="padding: ${padding}; border: 1px solid black; font-size: ${
              isCustomiseMode ? "7px" : "6px"
            }; font-family: samim;"></td>`;
          })
          .join("");

        return `<tr style="${rowStyle}">${rowCells}</tr>`;
      })
      .join("");

  const tabelDescription = properties?.descriptions
    ? properties.descriptions.map((item) => `<div>${item}</div>`).join("")
    : "";

  const tabelSigner = properties?.signers
    ? properties.signers.map(
        (item) =>
          `<span style="display: flex; align-items: center; justify-content: space-around; width: 100%">
          ${item.fullName || ""}${item.positionName || ""}
        </span>`
      )
    : [];

  const renderSigners = (reportId) => {
    if (!tabelSigner.length) return "";

    const signerConfigs = {
      166: { count: 3, cols: "1fr 1fr 1fr" },
      139: { count: 3, cols: "1fr 1fr 1fr" },
      103: { count: 5, cols: "1fr 1fr 1fr 1fr 1fr" },
      140: { count: 5, cols: "1fr 1fr 1fr 1fr 1fr" },
    };

    const config = signerConfigs[reportId];
    if (!config) return "";

    const signers = tabelSigner
      .slice(0, config.count)
      .map(
        (signer) =>
          `<div style="display: flex; align-items: center; justify-content: space-around; width: 100%; margin-top: 16px">
        ${signer}
      </div>`
      )
      .join("");

    return `<div style="display: grid; grid-template-columns: ${config.cols}">${signers}</div>`;
  };

  const renderCustomSigners = (reportId, companyCode) => {
    if (reportId !== 103 || companyCode != 17904) return "";

    if (isCustomiseMode) {
      return `
        <div style="display: flex; justify-content: space-around; gap: 16px;">
          <div style="display: flex; align-items: center; justify-content: space-around; width: 100%; margin-top: 16px">امور کارگزینی</div>
          <div style="display: flex; align-items: center; justify-content: space-around; width: 100%; margin-top: 16px">امور اداری</div>
          <div style="display: flex; align-items: center; justify-content: space-around; width: 100%; margin-top: 16px">مدیرتوسعه و منابع مرکز</div>
          <div style="display: flex; align-items: center; justify-content: space-around; width: 100%; margin-top: 16px">رئیس دانشگاه</div>
        </div>
      `;
    } else {
      return `
        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr 1fr 1fr">
          <div style="display: flex; align-items: center; justify-content: space-around; width: 100%; margin-top: 16px">345</div>
          <div style="display: flex; align-items: center; justify-content: space-around; width: 100%; margin-top: 16px">345</div>
          <div style="display: flex; align-items: center; justify-content: space-around; width: 100%; margin-top: 16px">${tabelSigner[2]}</div>
          <div style="display: flex; align-items: center; justify-content: space-around; width: 100%; margin-top: 16px">${tabelSigner[3]}</div>
          <div style="display: flex; align-items: center; justify-content: space-around; width: 100%; margin-top: 16px">${tabelSigner[4]}</div>
        </div>
      `;
    }
  };

  const renderExtraDetails = (extraDetails) => {
    if (!extraDetails || isCustomiseMode) return "";

    return `
      <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 4px; font-weight: bold; font-size: 7px">
        <div>تعداد مرخصی روزانه: ${extraDetails.dependentDailyLeaveCount ?? 0}</div>
        <div>تعداد مرخصی ساعتی: ${extraDetails.depenendHourlyLeaveCount ?? 0}</div>
        <div>مانده مرخصی از قبل: ${extraDetails.remainedLeave ?? 0}</div>
        <div>باز خرید: ${extraDetails.buyBack ?? 0}</div>
        <div>سوخت: ${extraDetails.burendOutTime ?? 0}</div>
      </div>
    `;
  };

  // حالت Customise: یک جدول واحد
  if (isCustomiseMode) {
    return `
      <div style="margin: 16px 0px"> 
        <table style="border-collapse: collapse; width: 100%; table-layout: ${isTotalReport ? "fixed" : "auto"}; font-family: Samim, sans-serif;">
          <thead>
            <th colspan="35" style="padding-bottom: 16px; font-family: Samim; text-align: center;">
              <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;">
                <div style="font-size: 1.2rem; margin-bottom: 6px;">${printTitle}</div>
                <div style="font-size: 0.6rem; margin-bottom: 6px;">
                  تاریخ گزارش گیری: ${formatDate(properties?.date)}
                </div>
                <div style="font-size: 0.6rem; display: flex; gap: 6px; justify-content: center;">
                  <div style="visibility: ${properties?.range ? "visible" : "hidden"}">
                    از تاریخ: ${formatDate(properties?.range?.start)}
                  </div>
                  <div style="visibility: ${properties?.range ? "visible" : "hidden"}">
                    تا تاریخ: ${formatDate(properties?.range?.stop)}
                  </div>
                </div>
              </div>
            </th>
            <tr style="background-color: #f2f2f2; font-weight: bold;">
              ${tableHeader}
            </tr>
          </thead> 
          <tbody style="text-align: center; margin: 0; padding: 0;">
            ${dataPrint
              .map((item, index) => {
                if (!item?.body?.length) return "";

                return `
                <tr>
                  <td colspan="35">
                    <div style="display: flex; align-items: center; justify-content: space-around; width: 100%">
                      <div>${PersonalInformation[index]?.department}</div>
                    </div>
                  </td>
                </tr>
                ${tabelRows(item.body)}
                <tr>
                  <td colspan="35" style="text-align: center; padding: 0; width: 100%;">
                    <div>${tabelDescription}</div>
                    ${renderSigners(props.report?.id)}
                    ${renderCustomSigners(props.report?.id, CompanyCode)}
                  </td>  
                </tr>
              `;
              })
              .join("")}
          </tbody>
        </table>
      </div>
    `;
  }

  // حالت عادی: هر آیتم یک جدول جداگانه
  return `
    <div style="margin: 48px 0px"> 
      ${dataPrint
        .map((item, index) => {
          if (!item?.body?.length) return "";

          return `
          <div>
            <div style="display: flex; align-items: center; justify-content: space-around; width: 100%">
              <div>
                <div>${PersonalInformation[index]?.department}</div>
              </div>
            </div>
            <table style="border-collapse: collapse; width: 100%; font-family: Samim, sans-serif;">
              <thead>
                <th colspan="35" style="padding-bottom: 0; font-family: Samim">
                  <div style="display: flex; justify-content: space-between;">
                    <div style="display: flex; align-items: center; justify-content: space-around; gap: 8px; font-weight: 300; font-size: 0.6rem">
                      <div>
                        <div>نام : ${PersonalInformation[index]?.personName}</div>
                        <div>شماره پرسنلی : ${PersonalInformation[index]?.personCode}</div>
                      </div>
                      <div>
                        <div>نام خانوادگی : ${PersonalInformation[index]?.personFamily}</div>
                        <div>نوع استخدام : ${PersonalInformation[index]?.recruitmentType}</div>
                      </div>
                    </div>
                    <div style="font-size: 1.2rem">${printTitle}</div>
                    <div style="text-align: center; font-weight: 300; font-size: 0.6rem">
                      <div>تاریخ گزارش گیری: ${formatDate(properties?.date)}</div>
                      <div style="display: flex; gap: 8px">
                        <div style="visibility: ${
                          properties?.range ? "visible" : "hidden"
                        }">
                          از تاریخ: ${formatDate(properties?.range?.start)}
                        </div>
                        <div style="visibility: ${
                          properties?.range ? "visible" : "hidden"
                        }">
                          تا تاریخ: ${formatDate(properties?.range?.stop)}
                        </div>
                      </div>
                    </div>
                  </div>
                </th>
                <tr style="background-color: #f2f2f2; font-weight: bold;">
                  ${tableHeader}
                </tr>
              </thead>
              <tbody style="text-align: center">
                ${tabelRows(item.body)}
              </tbody>
            </table>
            
            ${renderExtraDetails(item.props.extraDetails)}
            
            <div style="margin-top: 16px">${tabelDescription}</div>
            
            ${renderSigners(props.report?.id)}
            ${renderCustomSigners(props.report?.id, CompanyCode)}
            
            ${
              index < dataPrint.length - 1 && pagePrint
                ? '<div style="page-break-after: always"></div>'
                : ""
            }
          </div>
        `;
        })
        .join("")}
    </div>
  `;
};

/**
 * Render report table header and return result
 * @param {Object} tableHeader - Table header configuration
 * @return {String} HTML header content
 */
export const renderTableHeader = (tableHeader) => {
  let tHeader = "";
  let tHeader_ = "";
  let parent = [];
  let colspan = 0;
  let count = 0;

  //without parent column
  for (let property in tableHeader) {
    count++;

    if (tableHeader.hasOwnProperty(property)) {
      if (
        tableHeader[property].props &&
        tableHeader[property].props?.parent &&
        tableHeader[property].props?.parent !== ""
      ) {
        if (parent[tableHeader[property].props?.parent]) {
          parent[tableHeader[property].props?.parent]++;
        } else {
          parent[tableHeader[property].props?.parent] = 1;
        }
        colspan++;
        tHeader_ += `
       <th  rowspan="1" style= "color:black;text-align:center; background-color: #ddd; padding:4px; border: 1px solid black;font-family: samim; font-weight: bold;font-size:7px">${tableHeader[property].title}</th>
      `;
      }
    }
  }

  //with parent column
  for (let property in tableHeader) {
    if (tableHeader.hasOwnProperty(property)) {
      if (
        tableHeader[property].props &&
        tableHeader[property].props?.parent &&
        tableHeader[property].props?.parent !== ""
      ) {
        if (parent[tableHeader[property].props?.parent]) {
          tHeader += `
       <th colspan="${
            parent[tableHeader[property].props?.parent]
          }" rowspan="1" style= "color:black;text-align:center; background-color: #ddd; padding:4px; border: 1px solid black;font-family: samim; font-weight: bold;font-size:7px">${
            tableHeader[property].props.name
          }</th>
      `;
          parent[tableHeader[property].props?.parent] = false;
        }
      } else {
        colspan++;
        tHeader += `
       <th rowspan="2" style= "color:black;text-align:center; background-color: #ddd; padding:4px; border: 1px solid black;font-family: samim; font-weight: bold;font-size:7px">${tableHeader[property].title}</th>
      `;
      }
    }
  }

  tHeader += `</tr><tr>${tHeader_}`;
  return `${tHeader} `;
};
